/*
 * @Description: 已发布爆料
 * @Author: pu.yuchun
 * @LastEditors: pu.yuchun
 * @Date: 2019-10-25 15:59:12
 * @LastEditTime: 2019-10-25 17:26:09
 */
'use strict';
angular
    .module('publishExplosionModule', [])
    .controller('publishExplosionCtrl', [
        '$scope',
        '$element',
        '$filter',
        'httpService',
        'explosionManageService',
        '$timeout',
        '$sce',
        '$q',
        'modalDialog',
        'newPageScrollPic',
        function(
            $scope,
            $element,
            $filter,
            httpService,
            explosionManageService,
            $timeout,
            $sce,
            $q,
            modalDialog,
            newPageScrollPic
        ) {
            initStatus();
            initData();
            /**
             * [initStatus description] 初始化参数
             */
            function initStatus() {
                $scope.status = {
                    inputData: '',
                    copyCurrPage: 1
                };
                $scope.data = {
                    listData: [],
                    keywords: '' //检索的关键词
                };
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: 12,
                    PAGECOUNT: 1,
                    ITEMCOUNT: 0
                };
                $scope.params = {
                    startTime: '',
                    endTime: '',
                    searchWord: '',
                    searchTime: '',
                    isPub: true,
                    currPage: $scope.page.CURRPAGE,
                    pageSize: $scope.page.PAGESIZE
                };
            }

            function initData() {
                requestData();
            }
            /**
             * [requestData description] 初始化列表数据
             */
            function requestData() {
                $scope.loadingPromise = httpService
                    .http(
                        '/mcnww/web/article/brokeList.do',
                        $scope.params,
                        'get'
                    )
                    .then(function(data) {
                        for (var i in data.data.ldata) {
                            data.data.ldata[i].imgurl = !!data.appendixMap[
                                data.data.ldata[i].id
                            ]
                                ? (function(array) {
                                      var imgurl = [];
                                      for (var j in array) {
                                          if (array[j].filePath != null&&array[j].fileType == 0) {
                                              imgurl.push(
                                                  angular.globalConfig
                                                      .pictureServer +
                                                      array[j].filePath
                                              );
                                          }
                                        //   if (
                                        //       array[j].fileType == 101 ||
                                        //       array[j].fileType == 201
                                        //   ) {
                                        //       if (!isNaN(array[j].fileName)) {
                                        //           downLoadVideo(
                                        //               array[j].fileName,
                                        //               array[j].fileType
                                        //           ).then(function(data) {
                                        //               imgurl.push(data);
                                        //           });
                                        //       }
                                        //   }
                                      }
                                      return imgurl;
                                  })(data.appendixMap[data.data.ldata[i].id])
                                : [];
                                data.data.ldata[i].videourl = !!data.appendixMap[
                                    data.data.ldata[i].id
                                ]
                                    ? (function(array) {
                                          var videourl = [];
                                          for (var j in array) {
                                              if (array[j].filePath != null&&array[j].fileType == 3) {
                                                videourl.push(
                                                    angular.globalConfig
                                                        .pictureServer +
                                                        array[j].filePath
                                                );
                                              }
                                          }
                                          return videourl;
                                      })(data.appendixMap[data.data.ldata[i].id])
                                : [];
                                data.data.ldata[i].audiourl = !!data.appendixMap[
                                    data.data.ldata[i].id
                                ]
                                    ? (function(array) {
                                          var audiourl = [];
                                          for (var j in array) {
                                              if (array[j].filePath != null&&array[j].fileType == 2) {
                                                audiourl.push(
                                                    angular.globalConfig
                                                        .pictureServer +
                                                        array[j].filePath
                                                );
                                              }
                                          }
                                          return audiourl;
                                      })(data.appendixMap[data.data.ldata[i].id])
                                : [];
                        }
                        /**
                         * [downLoadVideo description] 视屏展示
                         */
                        function downLoadVideo(id, libType) {
                            var deffer = $q.defer();
                            if (id == 'undefined') return;
                            httpService
                                .http(
                                    '/mcnww/web/cloud/getVideoUrl.do',
                                    { id: id, libType: libType },
                                    'get'
                                )
                                .then(function(data) {
                                    if (data.data) {
                                        deffer.resolve(data.data.videoUrl);
                                    }
                                });
                            return deffer.promise;
                        }

                        $scope.data.listData = data.data.ldata;
                        //遍历爆料列表，添加一个istrue属性
                        for (var i = 0; i < $scope.data.listData.length; i++) {
                            $scope.data.listData[i].istrue = false;
                        }
                        //获取报料列表的类型
                        for (var i = 0; i < data.data.ldata.length; i++) {
                            if (
                                data.appendixMap[
                                    String($scope.data.listData[i].id)
                                ].length == 1
                            ) {
                                $scope.data.listData[i].filetype =
                                    data.appendixMap[
                                        String($scope.data.listData[i].id)
                                    ][0].fileType;
                            } else if (
                                data.appendixMap[
                                    String($scope.data.listData[i].id)
                                ].length > 1
                            ) {
                                $scope.data.listData[i].filetype =
                                    data.appendixMap[
                                        String($scope.data.listData[i].id)
                                    ][1].fileType;
                            }
                        }
                        $scope.page = {
                            CURRPAGE: data.data.startPage,
                            PAGESIZE: data.data.pageSize,
                            ITEMCOUNT: data.data.totalResults,
                            PAGECOUNT: data.data.totalPages
                        };
                        findPicture($scope.data.listData, data.appendixMap);
                    });
            }

            /**
             * [openpic description]打开一个图片
             *
             * @param   {[type]}  items  [items description]
             *
             * @return  {[type]}         [return description]
             */
            $scope.openpic = function (items) {
                newPageScrollPic.alertScrollPic(items);
            }
            /**
             * [handleArticleContent description] 处理爆料正文
             * @param {[object]} [item] [description] 爆料信息
             * @return {[null]} [description]
             */
            $scope.handleArticleContent = function(item) {
                var contentArray = item.articleContent.split(/\n/);
                /*for (var i in contentArray) {
            contentArray[i] = contentArray[i].replace(/ /g, "&nbsp");
            contentArray[i] = "<p>" + contentArray[i] + "</p>";
        }*/
                for (var i = contentArray.length - 1; i >= 0; i--) {
                    var content = contentArray[i];
                    if (content === '') {
                        contentArray.splice(i, 1);
                    } else {
                        content = content.replace(/ /g, '&nbsp;');
                        contentArray[i] = '<p>' + content + '</p>';
                    }
                }
                item.articleContentCopy = $sce.trustAsHtml(
                    contentArray.join('')
                );
            };
            /**
             * [findPicture description] 图片比对
             */
            function findPicture(item, appendixMap) {
                for (var i = 0; i < item.length; i++) {
                    var items = appendixMap[item[i].id];
                    if (items.length > 0) {
                        item[i].imgUrl = items;
                    }
                }
            }
            /**
             * [queryByDropdown description] 筛选条件触发后请求数据
             * @param  {[type]} key   [description] 请求对象参数key
             * @param  {[type]} value [description] 请求对象值
             * @return {[type]}       [description] null
             */
            $scope.queryByDropdown = function() {
                $scope.params.startTime = $scope.status.startDate;
                $scope.params.endTime = $scope.status.endDate;
                requestData();
            };
            /**
             * [fullTextSearch description;全文检索]
             * @param  {[type]} ev [description:按下回车也能提交]
             */
            $scope.fullTextSearch = function(ev) {
                if (
                    (angular.isDefined(ev) && ev.keyCode == 13) ||
                    angular.isUndefined(ev)
                ) {
                    $scope.params.searchWord = $scope.data.keywords;
                    requestData();
                }
            };
            /**
             * [createProduct description] -新增爆料
             * @return {[type]} [description]
             */
            $scope.createExplosion = function() {
                explosionManageService
                    .createExplosion($scope.status)
                    .then(function(data) {
                        // requestData();
                        $scope.status.copyCurrPage = 1;
                        jumpToPage();
                    });
            };

            /**
             * [selectPageNum description] 切换每页显示的条数
             * @return {[type]} [description]
             */
            $scope.selectPageNum = function() {
                $scope.params.currPage = $scope.page.CURRPAGE;
                $scope.params.pageSize = $scope.page.PAGESIZE;
                $scope.status.copyCurrPage = 1;
                requestData();
            };
            /**
             * [pageChanged description]分页请求
             * @return {[type]} [description]
             */
            $scope.pageChanged = function() {
                $scope.params.currPage = $scope.page.CURRPAGE;
                $scope.status.copyCurrPage = $scope.page.CURRPAGE;
                // $scope.status.jumpToPageNum = $scope.page.CURRPAGE;
                requestData();
            };
            /**
             * [jumpToPage description:跳转指定页面]
             */
            $scope.jumpToPage = function() {
                jumpToPage();
            };

            function jumpToPage() {
                if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                    $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
                }
                $scope.params.currPage = $scope.status.copyCurrPage;
                $scope.page.CURRPAGE = $scope.status.copyCurrPage;
                requestData();
            }
        }
    ]);
